import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import ConsultationForm from "@/components/ConsultationForm";
import { Toaster } from "@/components/ui/sonner";

export default function ConsultationFormPage() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    axios.get(`${API}/settings?lite=true`).then(r => setSettings(r.data || {})).catch(() => {});
  }, []);
  const salonName = settings.salon_name || '';
  const salonLogo = settings.icon_logo_url || settings.logo_url || '';
  return (
    <div className="min-h-screen bg-background">
      <Toaster position="top-center" />
      <header className="border-b border-border bg-white/90 backdrop-blur-sm">
        <div className="max-w-3xl mx-auto px-4 flex items-center justify-between h-14">
          <Link to="/" className="flex items-center gap-2">
            {salonLogo ? (
              <img src={salonLogo} alt={salonName || 'Salon'} className="w-8 h-8 rounded-lg object-cover" />
            ) : (
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-bold text-xs">
                {((salonName || 'B')[0]).toUpperCase()}
              </div>
            )}
            <span className="font-semibold text-sm" style={{ fontFamily: 'Playfair Display' }}>{salonName}</span>
          </Link>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-4 py-8">
        <ConsultationForm onComplete={() => {}} />
      </div>
    </div>
  );
}
